module.exports = __webpack_public_path__ + "static/why-separate-8774ecb761a16766cabcb8afdcd1d518.png";